<script>
  import './projectPreviewTab.css'
  import { signerAddress } from 'svelte-ethers-store'
  export let currentStep, setCurrentStep, saleContract, rewardVisible
</script>

<div class="project-tabs">
  <ul class="list-none flex items-center scroller relative">
    <li
      class={currentStep === 1 ? 'active' : ''}
      on:click={() => setCurrentStep(1)}>
      <a>Project Details</a>
    </li>
    <li
      class={currentStep === 2 ? 'active' : ''}
      on:click={() => setCurrentStep(2)}>
      <a>Token Details</a>
    </li>
    {#if rewardVisible}
    <li
      class={currentStep === 3 ? 'active' : ''}
      on:click={() => setCurrentStep(3)}>
      <a>Rewards</a>
    </li>
    {/if}
    {#if $signerAddress}
      <li
        class={currentStep === 4 ? 'active' : ''}
        on:click={() => setCurrentStep(4)}>
        <a>My Transactions</a>
      </li>
    {/if}
  </ul>
</div>
